module.exports = __webpack_public_path__ + "img/13_28.afa930f6.png";